// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/Contract.yaml
// Generated: 2026-10-19T08:01:54.228Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreateContract, UpdateContract, Contract } from '@/types/forestry/Contract';

/**
 * Contract Service
 * CRUD operations for Contract via the ABP API.
 */
export const contractService = new EntityService<Contract, CreateContract, UpdateContract>(
  '/api/forestry/contract',
  'Contract',
);
